module.exports = __webpack_public_path__ + "static/moradadapaz-7a185a412b322b2cc246567366784d5d.png";